import { NgZone, Injector, ViewContainerRef } from '@angular/core';

export const appGlobal = {
  zone: null as unknown as NgZone,
  platformId: null as unknown as any,
  injector: null as unknown as Injector,
  viewContainerRef: null as unknown as ViewContainerRef,
};
